/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-04-27 18:15:57
 * @LastEditors: linxi
 * @LastEditTime: 2025-04-28 18:30:04
 */
import { Settinglable } from '../models/setting'
import { Tenant } from '../models/tenant'
import { API_PREFIX } from './constant'
import { Request } from './request'

export function getSettingDetail(): Request {
  return {
    url: `${API_PREFIX}/blade-user/user/tenant/detail`,
    method: 'GET',
  }
}

export interface SettingMessageParams {
  tenant?: Tenant
  functionList: Settinglable[]
  autoCreateFees?: any[]
}

export interface SettingTenantOneFunction {
  functionList: Settinglable[]
}
export function getSettingSave(body: SettingMessageParams): Request {
  return {
    url: `${API_PREFIX}/blade-user/user/tenant/save`,
    method: 'POST',
    body,
  }
}
export function getSettingOneSave(body: SettingTenantOneFunction): Request {
  return {
    url: `${API_PREFIX}/blade-user/user/tenant/save`,
    method: 'POST',
    body,
  }
}
